import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  breadcrumbs = signal<{ label: string; link?: string }[]>([]);

  setBreadcrumbs(breadcrumbs: { label: string; link?: string }[]) {
    this.breadcrumbs.set(breadcrumbs);
  }

  clearBreadcrumbs() {
    this.breadcrumbs.set([]);
  }
}
